import getTypes from '../../../../@Component/Domain/Entity/Type/Api/getTypes';

export default function canGetPortalDataSourceById()
{
    return getTypes().PortalDataSource.Type !== undefined;
}
